<template>
    <div class="scrollable">

        
        
        <div class="qrcontainer">
            
            <vue-qr backgroundColor="#111" colorLight="#111" class="qr" :text="qrUrl" colorDark="#ace715"></vue-qr>
            <p>Ваш QR на EWERT.</p>
            
        </div>
    </div>
    
</template>

<script>
import vueQr from 'vue-qr/src/packages/vue-qr.vue'
import { buildPublicCardUrl } from '@/lib/cardGateway'
export default {
    name: 'QRCard',
    components: {
        vueQr
    },
    computed: {
        qrUrl() {
            return buildPublicCardUrl(this.$route.params.id)
        }
    },
    data() {
        return {
            isMenuOpen: false
        };
    },
    methods: {
        toggleMenu() {
            this.isMenuOpen = !this.isMenuOpen;
        },
        
    }
}

</script>
<style scoped>
.scrollable {
    height: 100svh;
    overflow-y: hidden;
    padding: 20px 10px;
    padding-top: 0;

}
</style>
